package com.vizio.redwolf.utils

import com.vizio.redwolf.utils.clientprovider.ClientProvider
import io.ktor.client.HttpClient
import io.ktor.client.request.get
import io.ktor.client.request.url
import io.ktor.client.statement.bodyAsText

class URLRequestHttpClient(clientProvider: ClientProvider, private val clientConfig: ClientConfig) : URLRequestClient {
    private val httpClient: HttpClient = clientProvider.httpClient

    override suspend fun getDataFromUrl(urlString: String): HttpResult<String> {
        return safeHttpCall {
            httpClient.get {
                url(urlString)
                applyTimeout(clientConfig.timeout)
            }.bodyAsText()
        }
    }
}